import { Box, Message } from 'components/ui';
import { MixpassSale } from 'contracts';
import { BigNumber } from 'ethers';
import { futuraChainId } from 'utils/config';
import { calculateGasMargin } from 'utils/transactions';
import { notifyTx } from 'utils/notifications';
import BuyWhitelist from './BuyWhitelist';
import useFutura from 'hooks/useFutura';
import { FuturaDropStage } from '../../constants';
import RedemptionDaysLeft from './RedemptionDaysLeft';

interface PublicSaleProps {
  remainingSupply: BigNumber;
  paymentToken: any;
  price: BigNumber;
  contract: MixpassSale;
}

const PublicSale = ({ remainingSupply, paymentToken, price, contract }: PublicSaleProps) => {
  const isSoldOut = remainingSupply && remainingSupply.eq(0);
  const { dropStage } = useFutura();

  async function handleBuy(amount: number) {
    notifyTx({
      method: async () => {
        const estimateGas = await contract.estimateGas.buyPublicSale(amount);
        return contract.buyPublicSale(amount, {
          gasLimit: calculateGasMargin(estimateGas, 200000),
        });
      },
      chainId: futuraChainId,
      success: 'Transaction successful. Please redeem your Mixpass for Futura Mix NFTs right now.',
      error: 'An error occured while trying to buy your mixpass',
    });
  }

  return (
    <Box mt="4" py="2" px="3" mr="3" minHeight="150px" width="100%">
      <Box fontSize={2} fontWeight="bold" mb="2" width="100%">
        Public sale
      </Box>

      <Box mt={4}>
        {isSoldOut ? (
          <Message color="black">We have sold out</Message>
        ) : (
          <BuyWhitelist
            paymentToken={paymentToken}
            maxCount={10}
            onClick={handleBuy}
            price={price}
            remainingSupply={remainingSupply}
            networkId={futuraChainId}
            showAllocationWarning={false}
          />
        )}
      </Box>

      {
        dropStage === FuturaDropStage.MIXES_AVAILABLE && (
          <Box
            mt={3}
            mx={-3}
            p={3}
            background="black"
            borderRadius="8px"
          >
            <Box mb={3}>
              <RedemptionDaysLeft />
            </Box>
          </Box>
        )
      }
    </Box>
  );
};

export default PublicSale;
